<template>
  <v-list v-if="accountStore.isLoggedIn" density="compact" nav class="bg-vio">
    <v-list-item prepend-icon="far fa-tachometer-alt" :title="$t('sidenavigation.dashboard')" to="/dashboard" />
    <v-list-group v-if="isVisibleForAdmin('stats_users') || isVisibleForAdmin('stats_courses') || isVisibleForAdmin('stats_quiz_challenge') || isVisibleForAdmin('stats_training') || isVisibleForAdmin('stats_wbt') || isVisibleForAdmin('stats_views') || isVisibleForAdmin('stats_ratings')">
      <template #activator="{ props }">
        <v-list-item v-bind="props" prepend-icon="far fa-chart-line" :title="$t('sidenavigation.statistics')" />
      </template>
      <v-list-item v-if="isVisibleForAdmin('stats_users')" :title="$t('sidenavigation.user')" to="/analytics/users" />
      <v-list-item v-if="isVisibleForAdmin('stats_courses')" :title="$t('sidenavigation.courses')" to="/analytics/courses" />
      <v-list-item v-if="isVisibleForAdmin('stats_quiz_challenge')" :title="$t('sidenavigation.quizBattle')" to="/stats/quiz" />
      <v-list-item v-if="isVisibleForAdmin('stats_training')" :title="$t('sidenavigation.powerlearning')" to="/powerlearning/analytics" />
      <v-list-item v-if="isVisibleForAdmin('stats_wbt')" :title="$t('sidenavigation.wbtStatistics')" to="/stats/wbt" />
      <v-list-item v-if="isVisibleForAdmin('stats_views')" :title="$t('sidenavigation.views')" to="/stats/views" />
      <v-list-item v-if="isVisibleForAdmin('stats_ratings')" :title="$t('sidenavigation.reviews')" to="/stats/ratings" />
      <v-list-item v-if="isVisibleForAdmin('stats_user_activity')" :title="$t('sidenavigation.userActivity')" to="/superadmin/user-activity" />
    </v-list-group>
    <v-list-group v-if="isVisibleForAdmin('users') || isVisibleForAdmin('vouchers')">
      <template #activator="{ props }">
        <v-list-item v-bind="props" prepend-icon="far fa-users" :title="$t('sidenavigation.user')" :to="isVisibleForAdmin('users') ? '/users' : undefined" />
      </template>
      <v-list-item v-if="isVisibleForAdmin('users')" :title="$t('sidenavigation.accounts')" to="/users" />
      <v-list-item v-if="isVisibleForAdmin('user_roles')" :title="$t('sidenavigation.roles')" to="/user-roles" />
      <v-list-item v-if="isVisibleForAdmin('communities')" :title="$t('sidenavigation.communities')" to="/communities" />
      <v-list-item v-if="isVisibleForAdmin('vouchers')" :title="$t('sidenavigation.vouchers')" to="/vouchers" />
    </v-list-group>
    <v-list-item v-if="isVisibleForAdmin('tags')" prepend-icon="far fa-tags" :title="$t('sidenavigation.tags')" to="/tags" />
    <v-list-group v-if="isVisibleForAdmin('courses')">
      <template #activator="{ props }">
        <v-list-item v-bind="props" prepend-icon="far fa-graduation-cap" to="/courses" :title="$t('sidenavigation.course')" />
      </template>
      <v-list-item :title="$t('sidenavigation.coursesOverview')" to="/courses" />
      <v-list-item v-if="isVisibleForAdmin('course_assistant')" :active="isCourseAssistantRoute" :title="$t('sidenavigation.aiCourseAssistant')" to="/courses/assistant" />
      <v-list-item :title="$t('sidenavigation.courseLibrary')" to="/courses/templates" />
      <v-list-item :title="$t('sidenavigation.courseTemplates')" :to="getCoursesTemplatesRoute()" />
    </v-list-group>
    <v-list-group
      v-if="
        isVisibleForAdmin('learningmaterials') ||
        isVisibleForAdmin('questions') ||
        isVisibleForAdmin('suggested_questions') ||
        isVisibleForAdmin('categories') ||
        isVisibleForAdmin('forms') ||
        isVisibleForAdmin('tests') ||
        isVisibleForAdmin('appointments') ||
        isVisibleForAdmin('keywords') ||
        isVisibleForAdmin('news') ||
        isVisibleForAdmin('webinars') ||
        isVisibleForAdmin('advertisements')
      "
    >
      <template #activator="{ props }">
        <v-list-item v-bind="props" prepend-icon="far fa-spell-check" :title="$t('sidenavigation.contents')" />
      </template>
      <v-list-item v-if="isVisibleForAdmin('learningmaterials')" :title="$t('sidenavigation.learningMaterials')" to="/media-library" />
      <v-list-item v-if="isVisibleForAdmin('questions')" :title="$t('sidenavigation.questions')" :to="{ name: 'questions' }" />
      <v-list-item v-if="isVisibleForAdmin('suggested_questions')" :title="$t('sidenavigation.userSubmittedQuestions')" to="/suggested-questions" />
      <v-list-item v-if="isVisibleForAdmin('categories')" :title="$t('sidenavigation.questionCategory')" to="/categories" />
      <v-list-item v-if="isVisibleForAdmin('forms')" :title="$t('sidenavigation.forms')" to="/forms" />
      <v-list-item v-if="isVisibleForAdmin('tests')" :title="$t('sidenavigation.tests')" to="/tests" />
      <v-list-item v-if="isVisibleForAdmin('appointments')" :title="$t('sidenavigation.appointments')" to="/appointments" />
      <v-list-item v-if="isVisibleForAdmin('keywords')" :title="$t('sidenavigation.keywords')" to="/keywords" />
      <v-list-item v-if="isVisibleForAdmin('news')" :title="$t('sidenavigation.news')" to="/news" />
      <v-list-item v-if="isVisibleForAdmin('webinars')" :title="$t('sidenavigation.webinars')" to="/webinars" />
      <v-list-item v-if="isVisibleForAdmin('advertisements')" :title="$t('sidenavigation.advertisements')" to="/advertisements" />
    </v-list-group>
    <v-list-group v-if="isVisibleForAdmin('quiz_teams') || isVisibleForAdmin('competitions')">
      <template #activator="{ props }">
        <v-list-item v-bind="props" prepend-icon="far fa-book" :title="$t('sidenavigation.quizBattle')" />
      </template>
      <v-list-item v-if="isVisibleForAdmin('quiz_teams')" :title="$t('sidenavigation.quizTeams')" to="/quiz-teams" />
      <v-list-item v-if="isVisibleForAdmin('competitions')" :title="$t('sidenavigation.quizCompetitions')" to="/competitions" />
    </v-list-group>
    <v-list-item v-if="isVisibleForAdmin('comments')" prepend-icon="far fa-comment" :title="$t('sidenavigation.comments')" to="/comments" />
    <v-list-item v-if="typeOptions.length" prepend-icon="far fa-language" :title="$t('sidenavigation.translations')" to="/translations" />
    <v-list-group v-if="accountStore.isSuperAdmin || isVisibleForAdmin('settings') || isVisibleForAdmin('tenants') || isVisibleForAdmin('import') || isVisibleForAdmin('pages') || isVisibleForAdmin('mails') || isVisibleForAdmin('certificates')">
      <template #activator="{ props }">
        <v-list-item v-bind="props" prepend-icon="far fa-cog" :title="$t('sidenavigation.settings')" :to="isVisibleForAdmin('settings') ? '/settings' : undefined" />
      </template>
      <v-list-item v-if="isVisibleForAdmin('settings')" :title="$t('sidenavigation.app')" to="/settings">
        <!-- For intercom to attach to -->
        <template #append><span class="s-list-append">&nbsp;</span></template>
      </v-list-item>
      <v-list-item v-if="isVisibleForAdmin('integrations')" :title="$t('sidenavigation.integrationCenter')" to="/integrations" />
      <v-list-item v-if="isVisibleForAdmin('public_api')" :title="$t('sidenavigation.publicApiTokens')" to="/settings/public-api-tokens">
        <!-- For intercom to attach to -->
        <template #append><span class="s-list-append">&nbsp;</span></template>
      </v-list-item>
      <v-list-item v-if="isVisibleForAdmin('settings')" :title="$t('sidenavigation.translationRules')" to="/translation-rules" />
      <v-list-item v-if="accountStore.isSuperAdmin" :title="$t('sidenavigation.metafields')" to="/settings/metafields" />
      <v-list-item v-if="isVisibleForAdmin('tenants')" :title="$t('sidenavigation.tenants')" to="/tenants">
        <!-- For intercom to attach to -->
        <template #append><span class="s-list-append">&nbsp;</span></template>
      </v-list-item>
      <v-list-item v-if="isVisibleForAdmin('import')" :title="$t('sidenavigation.import')" to="/import">
        <!-- For intercom to attach to -->
        <template #append><span class="s-list-append">&nbsp;</span></template>
      </v-list-item>
      <v-list-item v-if="isVisibleForAdmin('pages')" :title="$t('sidenavigation.pages')" to="/pages" />
      <v-list-item v-if="isVisibleForAdmin('mails')" :title="$t('sidenavigation.emailTemplate')" to="/mails" />
      <v-list-item v-if="isVisibleForAdmin('certificates')" :title="$t('sidenavigation.certificateTemplates')" to="/certificate-templates" />
      <v-list-item v-if="isVisibleForAdmin('kee_credits')" :title="$t('sidenavigation.keeCredits')" to="/settings/kee-credits">
        <!-- For intercom to attach to -->
        <template #append><span class="s-list-append">&nbsp;</span></template>
      </v-list-item>
      <v-list-item v-if="accountStore.isSuperAdmin && (isStaging || isLocalhost)" :title="$t('sidenavigation.oldCronJobs')" to="/settings/old/cron-jobs" />
      <v-list-item v-if="accountStore.isSuperAdmin && (isStaging || isLocalhost)" :title="$t('sidenavigation.cronJobs')" to="/settings/cron-jobs" />
    </v-list-group>
    <v-list-item v-if="isVisibleForAdmin('bin')" prepend-icon="far fa-trash" :title="$t('sidenavigation.bin')" to="/bin" />
  </v-list>
</template>

<script setup lang="ts">
import { useAccountStore } from "@/modules/account/store"
import { useAdminAreaAccess } from "@/composables/adminAreaAccess"
import { isLocalDevelopmentHost } from "@/logic/environment"
import { useTranslationsTypes } from "@/modules/translations/composables/translationsTypes"
import { computed } from "vue"
import { useRoute } from "vue-router"

const accountStore = useAccountStore()
const { isVisibleForAdmin } = useAdminAreaAccess()
const route = useRoute()
const isCourseAssistantRoute = computed(() => route.path === "/courses/assistant" || route.path.startsWith("/courses/assistant/"))

const typeOptions = useTranslationsTypes()

const isStaging = computed(() => {
  return window.location.hostname === "myadmin.staging.keelearning.de"
})

const isLocalhost = computed(() => {
  return isLocalDevelopmentHost()
})

const getCoursesTemplatesRoute = () => {
  return {
    name: "courses-manage-templates",
    query: {
      filters: JSON.stringify(["active"]),
      tags: "[]",
    },
  }
}
</script>

<style lang="scss" scoped>
:deep(.v-list-item--nav .v-list-item-title) {
  line-height: 1.5rem; // Due to our font, otherwise the letter "g" gets cut off at the bottom
}
</style>
